module.exports = __webpack_public_path__ + "static/media/logo-instagram-png-fundo-transparente9.e80a4e4a.png";